const ms = require('ms');
const processCookies = require('./processCookies')

module.exports = ({ domain }) => {
    return function cookieMonster(req, res, next) {
        const { cookieMonster, clearCookies, setCookies } = processCookies(req)
        clearCookies.forEach((cookieName) => res.clearCookie(cookieName, {domain}))
        setCookies.forEach((cookie) => {
            res.cookie(cookie.cookieName, cookie.value, { maxAge: ms(cookie.duration), domain })
            req.log.debug({ middleware: 'cookieMonster', cookie: cookie.cookieName, value: cookie.value }, 'setting cookie'); 
        })
        res.locals.cookieMonster = cookieMonster
        return next();
    };
};
